import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState, useEffect, useCallback } from "react";
import "./cart.css";
import { useCartContext } from "../context";
import CartItem from "./CartItem";

const Cart = ({ openCart }) => {
  const [isCartOpen, setCartOpen] = useState(openCart);

  const { cart } = useCartContext();

  const totalPrice = Object.values(cart).reduce((total, product) => {
    return total + (product.price*product.quantity);
  }, 0);

  const closeCart = useCallback(() => {
    setCartOpen(false);
  }, []);

  useEffect(
    () => {
      setCartOpen(openCart);
    },
    [openCart],
    closeCart
  );
  if (!isCartOpen) {
    return null;
  } else {
    return (
      <div className="cart">
        <FontAwesomeIcon
          onClick={closeCart}
          className="cart-close-icon fa-2xl"
          icon={faTimes}
        />
        {/* <ShimmerCategoryList title items={4} categoryStyle="STYLE_SEVEN" /> */}
        <div>
          {Object.values(cart).map((product) => (
            <CartItem key={product.id} product={product} />
          ))}
        </div>
        <div className="conclude-cart">
            <div className="total-price-container">
                <p>Total Amount</p>
                <div className="total-price">${totalPrice.toFixed(2)}</div>
            </div>
            <div className="order-cart">
                <p>Check Out</p>
            </div>
        </div>
      </div>
    );
  }
};

export default Cart;
